import type { OnboardStep } from "@/shared/types/onboard.types";

export type DisplayOnboardStep = {
    code: string;
    label: string;
};

export const DISPLAY_ONBOARD_STEPS: DisplayOnboardStep[] = [
    {
        code: "TENANT_CREATED",
        label: "Создание изолированной базы данных для компании...",
    },
    {
        code: "TRIAL_STARTED",
        label: "Выпуск и автоматическое подключение SSL-сертификатов...",
    },
    {
        code: "DIRECTOR_CREATED",
        label: "Развертывание вашего персонального Telegram Mini App...",
    },
    {
        code: "EMAIL_SENT",
        label: "Отправка учетных данных на ваш Email...",
    },
];

export type StepVisualState = "pending" | "active" | "done" | "failed";

export function resolveStepVisualState(
    displayStep: DisplayOnboardStep,
    index: number,
    apiSteps: OnboardStep[],
): StepVisualState {
    const matched = apiSteps.find((step) => step.code === displayStep.code);

    if (matched?.status === "FAILED") return "failed";
    if (matched?.status === "OK") return "done";

    const firstPendingIndex = DISPLAY_ONBOARD_STEPS.findIndex((step) => {
        const apiStep = apiSteps.find((item) => item.code === step.code);
        return !apiStep || apiStep.status !== "OK";
    });

    if (firstPendingIndex === -1) return "done";
    if (index === firstPendingIndex) return "active";
    if (index < firstPendingIndex) return "done";
    return "pending";
}
